export const API_BASE_URL = "https://your-api-url.com/";
export const API_DEVELOPMENT = "development";
export const API_PRODUCTION = "production";
export const API_SUCCESS = 200;
